import React from 'react';
import ErrorPage from './ErrorPage';

const MaintenancePage = () => (
  <ErrorPage
    code="503"
    tone="warn"
    eyebrow="Under Maintenance"
    title="We'll be right back."
    message="Phonestream is undergoing scheduled maintenance. Your funds, NFTs, and on-chain data are safe — the chain doesn't pause for us. We'll be back online shortly."
    primaryCta={{ label: 'Refresh', onClick: () => window.location.reload() }}
    secondaryCta={{ label: 'Status on Telegram', href: 'https://t.me/phonestreamofficial' }}
    showSupport={false}
  />
);

export default MaintenancePage;
